export const cities = [
  { name: 'Colombo', code: 'Colombo' },
  { name: 'Kandy', code: 'Kandy' },
  { name: 'Galle', code: 'Galle' },
  { name: 'Jaffna', code: 'Jaffna' },
  { name: 'Negombo', code: 'Negombo' },
  { name: 'Trincomalee', code: 'Trincomalee' },
  { name: 'Batticaloa', code: 'Batticaloa' },
  { name: 'Matara', code: 'Matara' },
  { name: 'Kurunegala', code: 'Kurunegala' },
  { name: 'Anuradhapura', code: 'Anuradhapura' },
  { name: 'Ratnapura', code: 'Ratnapura' },
  { name: 'Badulla', code: 'Badulla' },
  { name: 'Puttalam', code: 'Puttalam' },
  { name: 'Kalutara', code: 'Kalutara' },
  { name: 'Gampaha', code: 'Gampaha' },
  { name: 'Hambantota', code: 'Hambantota' },
  { name: 'Monaragala', code: 'Monaragala' },
  { name: 'Polonnaruwa', code: 'Polonnaruwa' },
  { name: 'Nuwara Eliya', code: 'Nuwara Eliya' },
  { name: 'Kilinochchi', code: 'Kilinochchi' },
  { name: 'Mannar', code: 'Mannar' },
  { name: 'Vavuniya', code: 'Vavuniya' },
  { name: 'Ampara', code: 'Ampara' },
  { name: 'Matale', code: 'Matale' },
  { name: 'Kegalle', code: 'Kegalle' },
  { name: 'Mullaitivu', code: 'Mullaitivu' },
  { name: 'Kalmunai', code: 'Kalmunai' },
  { name: 'Beruwala', code: 'Beruwala' },
  { name: 'Chilaw', code: 'Chilaw' },
  { name: 'Avissawella', code: 'Avissawella' },
  { name: 'Wattala', code: 'Wattala' },
  { name: 'Moratuwa', code: 'Moratuwa' },
  { name: 'Dehiwala-Mount Lavinia', code: 'Dehiwala-Mount Lavinia' },
  { name: 'Ja-Ela', code: 'Ja-Ela' },
  { name: 'Homagama', code: 'Homagama' },
  { name: 'Maharagama', code: 'Maharagama' },
  { name: 'Panadura', code: 'Panadura' },
  { name: 'Kegalle', code: 'Kegalle' },
  { name: 'Embilipitiya', code: 'Embilipitiya' },
  { name: 'Horana', code: 'Horana' },
  { name: 'Ambalangoda', code: 'Ambalangoda' },
  { name: 'Balangoda', code: 'Balangoda' },
  { name: 'Weligama', code: 'Weligama' },
  { name: 'Hatton', code: 'Hatton' },
  { name: 'Point Pedro', code: 'Point Pedro' },
  { name: 'Eravur', code: 'Eravur' },
  { name: 'Pothuvil', code: 'Pothuvil' },
  { name: 'Kataragama', code: 'Kataragama' },
  { name: 'Dambulla', code: 'Dambulla' },
];
